import * as React from 'react';
import AzureMP from './mp/mp';
import { Typography, Card, CardContent, Grid } from '@material-ui/core';
import { _PortalState } from 'src/helpers/state';

export default class Video extends React.Component<{}, IVideoState> {

    constructor(props: {}) {
        super(props);

        this.state = {
            videotitle: ''
        }
    }

    public componentDidMount() {
        this.loadvideo(this.props['match'].params.id);
    }

    public componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.id !== this.props['match'].params.id) {
            const id = nextProps.match.params.id
            this.loadvideo(id);
        }
    }

    private loadvideo = (id: string) => {
        _PortalState.authProvider.getAccessToken().then(token => {
            fetch(_PortalState.ApiEndpoint + '/api/Video', {
                method: 'get',
                headers: {
                    'Authorization': 'Bearer ' + token.accessToken
                }
            })
                .then(res => res.json())
                .then((t) => {

                    fetch('/videos.json')
                        .then(res => res.json())
                        .then(videos => {
                            console.log(videos);
                            const video: string = videos['videos'].filter(v => v.id === id);
                            this.setState({ token: t.token, src: video[0]['src'], videotitle: video[0]['Title'] });
                        });
                })
        })
    }

    public render() {
        return (
            <Grid container={true} justify="center" spacing={0}>
                <Grid item={true} xs={12} md={12} lg={12}>
                    <Card>
                        {this.state.token && this.state.src &&
                            <AzureMP key={this.state.src} token={this.state.token} src={this.state.src} />
                        }
                        {/* {!this.state.token &&
                            <div style={{ height: '300px', backgroundColor: '#000000' }} />
                        } */}
                        <CardContent>
                            <Typography gutterBottom={true} variant="h5" component="h2">
                                {this.state.videotitle}
                            </Typography>
                            {/* <Typography variant="body2" color="textSecondary" component="p">
                                Een bedrijf kan zijn waardepropositie leveren aan de klanten door middel van verschillende kanalen. Effectief gebruik hiervan zorgt ervoor dat de waardepropositie snel, efficiënt en kosteneffectief geleverd kan worden. Een organisatie kan zijn klanten door middel van eigen kanalen (zoals winkels), partners, of een combinatie van kanalen bereiken.
          </Typography> */}
                        </CardContent>
                    </Card >
                </Grid>
            </Grid>

        )
    }
}

interface IVideoState {
    token?: string;
    src?: string;
    videotitle: string;
}



// WEBPACK FOOTER //
// ./src/components/video/Video.tsx